import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Dialog from "components/Dialog/Dialog";
import { selectors as JobDetailSelectors } from "store/modules/jobDetails";

function PreferDialog(props) {
    const { open, onClose, onCancel, onConfirm, position } = props;
    const companyName = useSelector(JobDetailSelectors.getCompanyName);

    return (
        <Dialog
            open={open}
            title={`Prefer ${position.fullName}?`}
            description={`You are about to add ${
                position.fullName
            } to ${companyName}'s list of preferred workers.`}
            onClose={onClose}
            onConfirm={onConfirm}
            onCancel={onCancel}
            alertType="question"
            icon="person_add"
        />
    );
}

PreferDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    position: PropTypes.object,
};

export default PreferDialog;
